import MessageBox from '../components/message-box'
import moment from 'moment'
import XPMotorApi from '@xpeng/xpmotors-jsbridge-api'
import JSBridge from '@xpeng/js-bridge'
import Report from '@xpeng/report-js'
import Cookie from 'js-cookie';

export const showToastError = (error: any) => {
  if (typeof error === 'string') {
    MessageBox.toast(error)
  } else if (typeof error === 'object' && error.code) {
    MessageBox.toast(`${error.msg || error.message || ''}`)
  } else if (error instanceof Error) {
    MessageBox.toast(error.toString())
  }
}

export function isAfterDay(date: string, day: number) {
  // date YYYY-MM-DD 是否是 day 内
  if (!date) {
    return true
  }
  const selectData = moment(date, 'YYYY-MM-DD')
  const currentData = moment().format('YYYY-MM-DD')
  const maxData = moment(currentData, 'YYYY-MM-DD').add(day, 'days')
  if (selectData.isAfter(maxData)) {
    // 7天后
    return true
  }
  return false
}

/**
 * 禁用webview原生分享按钮
 */
export function disableShareOpt() {
  XPMotorApi.setOnActionButtonShowingHandler(() => {
    return { data: { share: false } }
  })
}

/**
 * 关闭当前webview
 */
export function closeWebview() {
  JSBridge.callHandler('closeWindow', {})
}

/**
 * 设置webview全屏
 */
export function setFullScreen() {
  try {
    JSBridge.callHandler('setFullScreen', { fullScreen: true, darkMode: true })
  } catch (error) {}
}

/**
 * 从 useragent 获取 APP 版本信息，返回版本数组，如：[2, 15, 5]
 */
export function getAppVersionFromUserAgent(): number[] {
  const userAgent = window.navigator.userAgent.toLowerCase()
  const matchText = userAgent.match(/com\.(.*)\/\d{1,3}\.\d{1,3}\.\d{1,3}/)
  const appVersion =
    matchText && matchText.length ? matchText[0].split('/')[1] : '0.0.0'

  if (/\d{1,3}\.\d{1,3}\.\d{1,3}/.test(appVersion)) {
    return appVersion.split('.').map(Number)
  }

  return [0, 0, 0]
}

/**
 * 获取当前平台：android、iOS还是harmony
 */
export function getPlatform() {
  let u = navigator.userAgent
  let isHarmony = (u.indexOf('HarmonyOS') > -1 || u.indexOf('OpenHarmony') > -1) && u.indexOf('mycarinfoHarmony') > -1 //判断是否是鸿蒙终端
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //判断是否是 android终端
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //判断是否是 iOS终端
  if (isHarmony) {
    return 'harmony'
  } else if (isAndroid) {
    return 'android'
  } else if (isIOS) {
    return 'iOS'
  } else {
    return 'PC'
  }
}

export function formatTimestampToTxt(timestamp: number | null, format?: string): string {
  if (!timestamp) return '--'

  let tLen = timestamp.toString().length
  if (tLen === 0 || (tLen !== 13 && tLen !== 10)) return '--'

  let fTime = tLen === 10 ? timestamp * 1000 : timestamp
  return moment(fTime).format(format || 'YYYY-MM-DD HH:mm:ss')
}

export function formatVehiclePlate(plate: string): string {
  return plate.slice(0, 3) + '***' + plate.slice(6)
}

export function desensitizedVin(vin: string): string {
  return vin.length === 17 ? vin.slice(0, 3) + '***' + vin.slice(-4) : '--'
}

export function vehicleTypeToShopBrandName(code: string): string {
  const G3_SERIES = ['DA', 'DB', 'DE', 'DC']
  const P7_SERIES = ['ED']
  const P5_SERIES = ['DF']

  return G3_SERIES.includes(code) ? 'G3' : P7_SERIES.includes(code) ? 'P7' : P5_SERIES.includes(code) ? 'P5' : ''
}

/**
 * 适配跳页面
 * @param url 需要跳转的地址
 * @param innerData 内部协议需要独立传参
 */
export function jumpPage(url: string, innerData: any = {}): void {
  if (
    url.indexOf('http://') === 0 ||
    url.indexOf('https://') === 0 ||
    url.indexOf('./') === 0
  ) {
    // 增加延迟 用于上报数据
    setTimeout(() => {
      window.location.href = url
    }, 300)
  } else {
    XPMotorApi.getSdk().callHandler('openUrl', {
      url,
      data: innerData,
    })
  }
}

/**
 * 返回当前页面的环境，依赖于当前域名
 */
export function getClientEnv() {
  let env = 'dev'
  if (window.location.href.indexOf('.test.xiaopeng.local') !== -1) {
    env = 'test'
  } else if (window.location.href.indexOf('.deploy-test.xiaopeng.com') !== -1) {
    env = 'deploy'
  } else if (window.location.href.indexOf('.xiaopeng.com') !== -1) {
    env = 'product'
  }
  return env
}

export function getLogEnv() {
  return {
    product: 'production',
    dev: 'test',
    test: 'test',
    deploy: 'pre',
  }[getClientEnv()]
}

export function setUrlParameter(uri, key, value) {
  if (!value) {
    return uri
  }
  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
  var separator = uri.indexOf('?') !== -1 ? '&' : '?'
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2')
  } else {
    return uri + separator + key + '=' + value
  }
}

interface IReport {
  appid?: string
  so?: string
  id?: number | string // 推送活动的id
  vehicle_type?: string // 该页面适用的车型
  name?: string // 应用名称
}

/**
 * 埋点
 */
export function reportUserBehavior(
  { appid = 'P001', so = 'P001001', id = '', vehicle_type = '', name = '' }: IReport,
  type = 'event'
) {
  const report = new Report(
    {
      appid,
      so,
      id,
      vehicle_type,
      name,
    },
    {
      env: getLogEnv(),
    }
  )

  report.send({ type })
}

/**
 * 获取前端NLS
 * @returns {string}
 */
export function getOrCreateLocalId () {
  if (window && window.localStorage) {
    const ls = window.localStorage;
    let deviceId = ls.getItem('deviceId');
    if (deviceId) {
      return deviceId;
    } else {
      deviceId = `${(Math.random() * 1000000).toString(16)}_${new Date().getTime()}`;
      ls.setItem('deviceId', deviceId);
      return deviceId;
    }
  } else {
    return 'no_support_localStorage';
  }
};

/**
 * 获取用户登录状态
 */
export function getLoginInfoPromise(): Promise<any> {
  return new Promise((resolve, reject): void => {
    XPMotorApi.getSdk()
      .callHandler('getLoginState', {})
      .then((res: any): void => {
        // loginState: true / false
        // data: {uid,username,avatar,mobile,carownerflag} | {}
        if (!res.loginState) {
          reject(false);
        } else {
          resolve(res.data);
        }
      })
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * ios 解决页面返回不刷新问题
 */
export function refreshPageByBack() {
  if (getPlatform() === 'iOS') {
    let isPageHide = false
    console.log('------> page <--------')
    window.addEventListener('pageshow', function () {
      if (isPageHide) {
        console.log('------> pageshow <------')
        window.location.reload()
      }
    })
    window.addEventListener('pagehide', function () {
      console.log('------> pagehide <------')
      isPageHide = true
    })
  }
}

export const uuidGenerator = (len?, radix?) => {
	const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	let uuid: Array<any> = [], i;
	radix = radix || chars.length;
	len = len || 16;

	if (len) {
		// Compact form
		for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
	} else {
		// rfc4122, version 4 form
		let r;

		// rfc4122 requires these characters
		uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
		uuid[14] = '4';

		// Fill in random data.  At i==19 set the high bits of clock sequence as
		// per rfc4122, sec. 4.1.5
		for (i = 0; i < 36; i++) {
			if (!uuid[i]) {
				r = 0 | Math.random() * 16;
				uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
			}
		}
	}

	return uuid.join('');
};


// 获取设备ID
export const getDeviceId = (cookieName: string) => {
	if (Cookie.get(cookieName)) {
		return Cookie.get(cookieName);
	} else {
		const deviceId = uuidGenerator();
		Cookie.set(cookieName, deviceId, { expires: 7, path: '/' });
		return deviceId;
	}
};


/**
 * 单位换算：KB -> MB/GB，保留两位小数
 */
export function formatFileSize(size: number, type: string): number {
  if (type === 'MB') {
    return Number((size / 1024).toFixed(2))
  }
  if (type === 'GB') {
    return Number((size / 1024 / 1024).toFixed(2))
  }
  return 0
}

/**
 * 判断一个元素是否在可视窗口内
 * @param element 
 * @returns
 */
export function isInViewPort(element) {
  const viewWidth = window.innerWidth || document.documentElement.clientWidth;
  const viewHeight = window.innerHeight || document.documentElement.clientHeight;
  const {
    top,
    right,
    bottom,
    left,
  } = element.getBoundingClientRect();

  return (
    top >= 0 &&
    left >= 0 &&
    right <= viewWidth &&
    bottom <= viewHeight
  );
}